import { Component } from '@angular/core';
import { faArrowRight, faCheck } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-business-plan',
  templateUrl: './business-plan.component.html',
  styleUrls: ['./business-plan.component.scss',],
})
export class BusinessPlanComponent {

  businessPlan = [
    {
      cardHead: 'DriveX by PumPumPum', subheading: 'Pre-Owned Car Lease', text: 'We will create an employee car lease policy for your custom needs onboard your business on our digital platform.',
      listPoints: ['We help your employees drive their Aspirational Cars while taking upto 30% tax benefits.',],
    },
    {
      cardHead: 'Link with PumPumPum', subheading: 'Lease your own car', text: 'We will create an employee car lease policy for your custom needs onboard your business on our digital platform.',
      listPoints: ['Now your employees can save Upto 30% on Tax on their existing car while unblocking the capital spent on their vehicle.',],
    },
    {
      cardHead: 'Elevate with PumPumPum', subheading: 'Sale & Upgrade', text: 'We will create an employee car lease policy for your custom needs onboard your business on our digital platform.',
      listPoints: ['Your employees simply sell their existing car at its market value to PumPumPum and drive away with their aspirational car on lease.',],
    },
  ];
  faCheck = faCheck;
  faArrowRight = faArrowRight;
}
